/*
 *
 *
 *
 *   Copyright (c) 2022. TinyMedic Pvt Ltd  - All Rights Reserved.
 *   This file is part of the API module  of the project: TinyMedic-Platform.
 *
 *
 *   Proprietary and confidential.
 *
 *   Unauthorized copying of this file, via any medium is strictly prohibited.
 *    Any resources of   TinyMedic-Platform can not be copied and/or distributed without the express permission of TinyMedic Pvt Ltd.
 *
 *
 *
 */

import React, { useEffect } from 'react';
import { Link, useParams } from 'react-router-dom';
import { Button, Col, Row } from 'reactstrap';
import { Translate } from 'react-jhipster';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { useAppDispatch, useAppSelector } from 'app/config/store';

import { getEntity } from './template-prescription.reducer';

export const TemplatePrescriptionDetail = () => {
  const dispatch = useAppDispatch();

  const { id } = useParams<'id'>();

  useEffect(() => {
    dispatch(getEntity(id));
  }, []);

  const templatePrescriptionEntity = useAppSelector(state => state.templatePrescription.entity);
  return (
    <Row>
      <Col md="8">
        <h2 data-cy="templatePrescriptionDetailsHeading">
          <Translate contentKey="tinyMedicRestApp.templatePrescription.detail.title">TemplatePrescription</Translate>
        </h2>
        <dl className="jh-entity-details">
          <dt>
            <span id="id">
              <Translate contentKey="tinyMedicRestApp.templatePrescription.id">Id</Translate>
            </span>
          </dt>
          <dd>{templatePrescriptionEntity.id}</dd>
          <dt>
            <span id="active">
              <Translate contentKey="tinyMedicRestApp.templatePrescription.active">Active</Translate>
            </span>
          </dt>
          <dd>{templatePrescriptionEntity.active ? 'true' : 'false'}</dd>
          <dt>
            <span id="cursor">
              <Translate contentKey="tinyMedicRestApp.templatePrescription.cursor">Cursor</Translate>
            </span>
          </dt>
          <dd>{templatePrescriptionEntity.cursor}</dd>
          <dt>
            <span id="timestampEntry">
              <Translate contentKey="tinyMedicRestApp.templatePrescription.timestampEntry">Timestamp Entry</Translate>
            </span>
          </dt>
          <dd>{templatePrescriptionEntity.timestampEntry}</dd>
          <dt>
            <span id="lastUpdated">
              <Translate contentKey="tinyMedicRestApp.templatePrescription.lastUpdated">Last Updated</Translate>
            </span>
          </dt>
          <dd>{templatePrescriptionEntity.lastUpdated}</dd>
          <dt>
            <span id="microSec">
              <Translate contentKey="tinyMedicRestApp.templatePrescription.microSec">Micro Sec</Translate>
            </span>
          </dt>
          <dd>{templatePrescriptionEntity.microSec}</dd>
          <dt>
            <span id="patientType">
              <Translate contentKey="tinyMedicRestApp.templatePrescription.patientType">Patient Type</Translate>
            </span>
          </dt>
          <dd>{templatePrescriptionEntity.patientType}</dd>
          <dt>
            <span id="templateName">
              <Translate contentKey="tinyMedicRestApp.templatePrescription.templateName">Template Name</Translate>
            </span>
          </dt>
          <dd>{templatePrescriptionEntity.templateName}</dd>
          <dt>
            <span id="forSymptom">
              <Translate contentKey="tinyMedicRestApp.templatePrescription.forSymptom">For Symptom</Translate>
            </span>
          </dt>
          <dd>{templatePrescriptionEntity.forSymptom}</dd>
          <dt>
            <span id="liver">
              <Translate contentKey="tinyMedicRestApp.templatePrescription.liver">Liver</Translate>
            </span>
          </dt>
          <dd>{templatePrescriptionEntity.liver}</dd>
          <dt>
            <span id="GFR">
              <Translate contentKey="tinyMedicRestApp.templatePrescription.GFR">GFR</Translate>
            </span>
          </dt>
          <dd>{templatePrescriptionEntity.GFR}</dd>
          <dt>
            <span id="weightMin">
              <Translate contentKey="tinyMedicRestApp.templatePrescription.weightMin">Weight Min</Translate>
            </span>
          </dt>
          <dd>{templatePrescriptionEntity.weightMin}</dd>
          <dt>
            <span id="weightMax">
              <Translate contentKey="tinyMedicRestApp.templatePrescription.weightMax">Weight Max</Translate>
            </span>
          </dt>
          <dd>{templatePrescriptionEntity.weightMax}</dd>
          <dt>
            <span id="assessment">
              <Translate contentKey="tinyMedicRestApp.templatePrescription.assessment">Assessment</Translate>
            </span>
          </dt>
          <dd>{templatePrescriptionEntity.assessment}</dd>
          <dt>
            <span id="diagnosisNotes">
              <Translate contentKey="tinyMedicRestApp.templatePrescription.diagnosisNotes">Diagnosis Notes</Translate>
            </span>
          </dt>
          <dd>{templatePrescriptionEntity.diagnosisNotes}</dd>
          <dt>
            <span id="medicationPlan">
              <Translate contentKey="tinyMedicRestApp.templatePrescription.medicationPlan">Medication Plan</Translate>
            </span>
          </dt>
          <dd>{templatePrescriptionEntity.medicationPlan}</dd>
          <dt>
            <Translate contentKey="tinyMedicRestApp.templatePrescription.owner">Owner</Translate>
          </dt>
          <dd>{templatePrescriptionEntity.owner ? templatePrescriptionEntity.owner.id : ''}</dd>
          <dt>
            <Translate contentKey="tinyMedicRestApp.templatePrescription.hospital">Hospital</Translate>
          </dt>
          <dd>{templatePrescriptionEntity.hospital ? templatePrescriptionEntity.hospital.id : ''}</dd>
          <dt>
            <Translate contentKey="tinyMedicRestApp.templatePrescription.speciality">Speciality</Translate>
          </dt>
          <dd>{templatePrescriptionEntity.speciality ? templatePrescriptionEntity.speciality.id : ''}</dd>
        </dl>
        <Button tag={Link} to="/template-prescription" replace color="info" data-cy="entityDetailsBackButton">
          <FontAwesomeIcon icon="arrow-left" />{' '}
          <span className="d-none d-md-inline">
            <Translate contentKey="entity.action.back">Back</Translate>
          </span>
        </Button>
        &nbsp;
        <Button tag={Link} to={`/template-prescription/${templatePrescriptionEntity.id}/edit`} replace color="primary">
          <FontAwesomeIcon icon="pencil-alt" />{' '}
          <span className="d-none d-md-inline">
            <Translate contentKey="entity.action.edit">Edit</Translate>
          </span>
        </Button>
      </Col>
    </Row>
  );
};

export default TemplatePrescriptionDetail;
